export default function GuideLines(props) {
    return (
        <div className="tg23-guidlines-wrapper">
            <p className="tg23-section-heading" data-value="GUIDELINES" onMouseOver={props.mouseHover}>GUIDELINES</p>
            <ul className="tg23-points">
                <li>Use of mobile phones during the event is strictly prohibited.</li>
                <li>Respect the judges and fellow participants at all times</li>
                <li>All participants must adhere to the event schedule and follow the instructions provided by us</li>
                <li>Coordinators will be present to guide students and help them with any doubts that may arise</li>
                <li>The event will be conducted offline at SVKM's Dwarkadas J. Sanghvi College of Engineering campus in Vile Parle, Mumbai, India</li>
                <li>If any participant is caught cheating, it will be an immediate disqualification</li>
                <li>All participants are requested to get their identities verified before hand</li>
                <li>Volunteers and mentors will be present in case participants face any difficulty</li>
                <li>Participants are requested to maintain college decorum</li>
                <li>Participants will be responsible for their belongings</li>
                <li>Required materials will be provided during the event</li>
                <li>Register before the deadline, last minute entries will not be entertained</li>
                <li>The decision of the judges will be final and binding in all matters</li>
            </ul>
        </div>
    )
}